import { useRef, useState } from 'react';
import { useIonViewWillEnter } from '@ionic/react';
import { useRepositories } from '../../../infrastructure/http/RepositoryProvider';
import type { AdminStats } from '../../../domain/Admin';

export function useAdminHome() {
  const { admin } = useRepositories();
  const [stats, setStats] = useState<AdminStats | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  // El spinner es solo para la primera carga: al volver a la pantalla (o en
  // cada refresco) los datos se actualizan sin mover la página.
  const loadedRef = useRef(false);

  useIonViewWillEnter(() => {
    if (!loadedRef.current) setLoading(true);
    setError(null);
    admin
      .fetchStats()
      .then(setStats)
      .catch((err) => setError(err instanceof Error ? err.message : 'No se pudo cargar el resumen.'))
      .finally(() => {
        loadedRef.current = true;
        setLoading(false);
      });
  });

  return { stats, error, loading };
}
